export default "__VITE_ASSET__xSDVpFEQ__"